import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTrashLines = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.3 4.8H14.7M7.05 4.65V3.45C7.05 3.25109 7.12902 3.06032 7.26967 2.91967C7.41032 2.77902 7.60109 2.7 7.8 2.7H10.2C10.3989 2.7 10.5897 2.77902 10.7303 2.91967C10.871 3.06032 10.95 3.25109 10.95 3.45V4.65M4.8 4.95L5.4 14.55C5.41866 14.7356 5.50584 14.9077 5.64452 15.0325C5.7832 15.1573 5.96342 15.2259 6.15 15.225H11.85C12.0366 15.2259 12.2168 15.1573 12.3555 15.0325C12.4942 14.9077 12.5813 14.7356 12.6 14.55L13.2 4.95M7.5 7.8V12.6M10.5 7.8V12.6",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgTrashLines;
